import { BookADemo } from '../Home/BookADemo'
import { OurClients } from '../Home/OurClients'
import { ContentCapabilities } from './ContentCapabilities'
import { EngagementModel } from './EngagementModel'
import { GrowthPillars } from './GrowthPillars'
import { Hero } from './Hero'
import { TalentCarousel } from './TalentCarousel'
import { ValueSection } from './ValueSection'
import { ComparisonGrid } from './ComparisonGrid'
import { CaseStudies } from '../Home/CaseStudies'
import type { SolutionPageData } from '@/data/solutions/types'

type SolutionsTemplateProps = {
  solutionData: SolutionPageData
}

export const SolutionsTemplate = ({ solutionData }: SolutionsTemplateProps) => {
  return (
    <main className="max-w-screen-2xl mx-auto md:px-[8%] px-6 | grid grid-cols-1 gap-14 md:gap-32 | font-body">
      <section>
        <Hero {...solutionData.hero} />
      </section>

      <section>
        <OurClients data={solutionData.clients} />
      </section>

      <section>
        <ContentCapabilities {...solutionData.capabilities} />
      </section>

      <section>
        <GrowthPillars {...solutionData.growthPillars} />
      </section>

      <section>
        <ComparisonGrid {...solutionData.comparisonGrid} />
      </section>

      <section>
        <CaseStudies data={solutionData.caseStudies} />
      </section>

      <section>
        <EngagementModel {...solutionData.engagementModel} />
      </section>

      <section>
        <TalentCarousel />
      </section>

      <section>
        <ValueSection {...solutionData.valueSection} />
      </section>

      <section>
        <BookADemo />
      </section>
    </main>
  )
}
